import { standerdDateForDataCreation } from "../utils/dataFilter";
import http, { host } from "./httpService";

export const getTransporterData = async (date) => {
  const response =  await http.get(host + "GetTransportData", { params: { _fromdate: date.fromdate, _todate:date.todate } });
  return response.data.map((item)=>{
    return {
      ...item,
      Date : standerdDateForDataCreation(item.Date)
    }
  })
};

export const getCarrierwiseContainerCount = async (date) => {
  return await http.get(host + "GetAryabhataContainerCount", { params: { fromdate: date.fromdate, todate:date.todate }})
}

export const addTransporterData = async (data) => {
  return await http.post(host + "AddAbTransportData", { _jsonTrnMaster: data,});
};

export const addAggregateTransporterData = async (data) => {
  return await http.post(host + "AddAggregateTransportData", {
    _AggregateTrnMaster: data,
  });
};

export const add5MTransporterData = async (data) => {
  return await http.post(host + "Add5MTransportData", {
    _5MTrnMaster: data,
  });
};

export const updateTransporterData = async (data) => {
  return await http.put(host + "UpdateSingleRowforTranspoter", data);
}
export const updateAggregateTransporterData = async (data) => {
  return await http.put(host + "UpdateSingleRowforAggregateTranporter", data);
}
export const update5MTransporterData = async (data) => {
  return await http.put(host + "UpdateSingleRowfor5MTranporter", data);
}

export const GetDailyContainerPlanningIdFromBookingNum = async (data) => {
  return await http.get(host + `GetDailyContainerPlanningIdFromBooking?BookingNo=${data}`)
}

export const GetDailyContainerplanningAggIdFromBookingNum = async (data) => {
  return await http.get(host + `GetDailyContainerplanningAggIdFromBooking?BookingNo=${data}`)
}

export const GetDailyContainerplanning5MIDFromBookingNum = async (data) => {
  return await http.get(host + `GetDailyContainerplanning5MIDFromBooking?BookingNo=${data}`)
}

export const deleteTransporterDataTractor = async (data, action) => {
  return await http.delete(host + "DeleteAryabhata_TransporterData", {params:{_id:data, _IsConData: action}})
}

export const deleteTransporterDataAggregate = async (data, action) => {
  return await http.delete(host + "DeleteAryabhataAggregate_TransporterData", {params:{_id:data, _IsConData: action}})
}

export const deleteTransporterDataFiveM = async (data, action) => {
  return await http.delete(host + "DeleteAryabhata5M_TransporterData", {params:{_id:data, _IsConData: action}})
}

export const deleteAllTransporterData = async (data) => {
  return await http.delete(host + "DeleteMultipleTransporterData", {data:{_Bulkdelete : data}}, );
};